import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { selectSubMenu } from '../../actions';
import './InsertMachine.css'; // Importa el archivo CSS
import { insertMachine } from '../general/api';

const InsertMachine = ({ navigationHistory }) => {
    const user = useSelector((state) => state.auth.user);
    const dispatch = useDispatch();
    const [formData, setFormData] = useState({
        id: '',
        ref: '',
        location: '',
        name: '',
        internal_code: '',
        state: '',
        inst_date: '',
        observation: '',
        company_id: '',
        priority: '',
        imagen: null,
        pdf: null
    });

    const [loading, setLoading] = useState(false);
    const [progress, setProgress] = useState(0);

    const handleReturn = () => {
        dispatch(selectSubMenu(navigationHistory[navigationHistory.length - 2]));
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value
        });
    };

    const handleFileChange = (e) => {
        const { name, files } = e.target;
        setFormData({
            ...formData,
            [name]: files[0]
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setProgress(0);

        const interval = setInterval(() => {
            setProgress((prev) => {
                if (prev >= 100) {
                    clearInterval(interval);
                    return 100;
                }
                return prev + 20; // Incrementar en 20 cada segundo (5 segundos al 100%)
            });
        }, 1000);

        try {
            const response = await insertMachine(user, formData, formData.imagen, formData.pdf);
            dispatch(selectSubMenu(navigationHistory[navigationHistory.length - 2]));
            alert(JSON.stringify(response));
        } catch (error) {
            console.error(error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="form-container">
            <form onSubmit={handleSubmit}>
                <label>
                    <strong>Referencia de la Máquina: </strong>
                    <input type="text" name="ref" value={formData.ref} onChange={handleChange} required />
                </label>
                <label>
                    <strong>Ubicación de la Máquina: </strong>
                    <input type="text" name="location" value={formData.location} onChange={handleChange} required />
                </label>
                <label>
                    <strong>Nombre de la Máquina: </strong>
                    <input type="text" name="name" value={formData.name} onChange={handleChange} required />
                </label>
                <label>
                    <strong>Código Interno de la Máquina: </strong>
                    <input type="text" name="internal_code" value={formData.internal_code} onChange={handleChange} required />
                </label>
                <label>
                    <strong>Estado de la Máquina: </strong>
                    <select name="state" value={formData.state} onChange={handleChange} required>
                      <option value="">Selecciona un estado</option>
                      <option value="En operacion">En operación</option>
                      <option value="En mantenimiento">En mantenimiento</option>
                      <option value="Fuera de servicio">Fuera de servicio</option>
                      <option value="En espera">En espera</option>
                      <option value="En instalacion">En instalación</option>
                      <option value="Desactivada">Desactivada</option>
                      <option value="En calibracion">En calibración</option>
                      <option value="En prueba">En prueba</option>
                      <option value="Reservada">Reservada</option>
                      <option value="En diagnostico">En diagnóstico</option>
                    </select>
                </label>
                <label>
                    <strong>Fecha de Instalación de la Máquina: </strong>
                    <input type="date" name="inst_date" value={formData.inst_date} onChange={handleChange} required />
                </label>
                <label>
                    <strong>Observación de la Máquina: </strong>
                    <input type="text" name="observation" value={formData.observation} onChange={handleChange} required />
                </label>
                <label>
                    <strong>Prioridad de la Máquina: </strong>
                    <input type="number" name="priority" value={formData.priority} onChange={handleChange} required />
                </label>
                <label>
                    <strong>Imagen de la Máquina: </strong>
                    <input type="file" name="imagen" onChange={handleFileChange} />
                </label>
                <label>
                    <strong>Manual pdf de la Máquina: </strong>
                    <input type="file" name="pdf" onChange={handleFileChange} />
                </label>
                <div className="button-container">
                    <button onClick={handleReturn} disabled={loading}>Regresar</button>
                    <button type="submit" disabled={loading}>Insertar Máquina</button>
                </div>
                {loading && (
                    <div className="progress-bar">
                        <div className="progress" style={{ width: `${progress}%` }}></div>
                    </div>
                )}
            </form>
        </div>
    );
}

export default InsertMachine;
